import { StorageAdapter } from './storage-adapter';

export class MemoryStorageAdapter implements StorageAdapter {
	private static videoFile: File | null = null;
	private static posterFile: File | null = null;

	async save(file: File, type: 'video' | 'poster'): Promise<void> {
		if (type === 'video') {
			MemoryStorageAdapter.videoFile = file;
		} else {
			MemoryStorageAdapter.posterFile = file;
		}
	}

	async load(type: 'video' | 'poster'): Promise<File | null> {
		return type === 'video' ? MemoryStorageAdapter.videoFile : MemoryStorageAdapter.posterFile;
	}

	async delete(): Promise<void> {
		MemoryStorageAdapter.videoFile = null;
		MemoryStorageAdapter.posterFile = null;
	}
}
